import { ZCodeDto } from '@act/shared/data-transfer-objects';
import { Box, List, ListItem, Typography } from '@mui/material';

interface ZCodeContentProps {
  zcode: ZCodeDto;
}

export const ZCodeContent = ({ zcode }: ZCodeContentProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        paddingTop: '12px',
      }}
    >
      <Box>
        <Typography variant="subheadLarge">Overview</Typography>
      </Box>
      <Box>
        <Typography variant="bodyLarge">{zcode?.overview}</Typography>
      </Box>
      <Box>
        <Typography variant="subheadLarge">What's included</Typography>
      </Box>
      <Box>
        <Typography variant="bodyLarge">
          <List dense sx={{ paddingTop: 0 }}>
            {zcode?.issues?.map(issue => (
              <ListItem key={issue}>{`•  ${issue}`}</ListItem>
            ))}
          </List>
        </Typography>
      </Box>
      <Box>
        <Typography variant="subheadLarge">How to help</Typography>
      </Box>
      <Box>
        <Typography variant="bodyLarge">
          <List dense sx={{ paddingTop: 0 }}>
            {zcode?.assistances?.map(assistance => (
              <ListItem key={assistance}>{`•  ${assistance}`}</ListItem>
            ))}
          </List>
        </Typography>
      </Box>
    </Box>
  );
};

export default ZCodeContent;
